import { create } from "zustand";

interface IChangePasswordModal {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}

export const useChangePasswordModal = create<IChangePasswordModal>()((set) => ({
  isOpen: false,
  onOpen: () => {
    set(() => ({ isOpen: true }));
  },
  onClose: () => {
    set(() => ({ isOpen: false }));
  },
}));
